import React, { Component } from 'react';
import { Admin, Resource } from 'react-admin';
import parseHydraDocumentation from '@api-platform/api-doc-parser/lib/hydra/parseHydraDocumentation';
import { hydraClient, fetchHydra as baseFetchHydra } from '@api-platform/admin';
import { reducer as tree } from 'ra-tree-ui-materialui';
//import treeEnglishMessages from 'ra-tree-language-english';
import authProvider from './auth/authProvider';
import { Redirect } from 'react-router-dom';
//import { Resource } from 'react-admin';
import customAdminRoutes from './customRoutes';
import CustomLogin from './auth/CustomLogin';
//import CustomLogoutButton from './CustomLogoutButton';
//import { User } from './components/User';
//import { Thread } from './components/Thread';
//import { Post } from './components/Post';
import { createMuiTheme } from '@material-ui/core/styles';
import UserIcon from '@material-ui/icons/Group';
import { UserList } from './components/user/UserList';
import { UserShow } from './components/user/UserShow';
import { UserEdit } from './components/user/UserEdit';
import { UserCreate } from './components/user/UserCreate';
import PostIcon from '@material-ui/icons/Comment';
import { PostList } from './components/post/PostList';
import { PostShow } from './components/post/PostShow';
import { PostEdit } from './components/post/PostEdit';
import PostCreate from './components/post/PostCreate';
import ThreadIcon from '@material-ui/icons/Book';
import { ThreadList } from './components/thread/ThreadList';
import { ThreadShow } from './components/thread/ThreadShow';
import { ThreadEdit } from './components/thread/ThreadEdit';
import { ThreadCreate } from './components/thread/ThreadCreate';

const theme = createMuiTheme({
    palette: {
        type: 'light'
    },
});

const entrypoint = process.env.REACT_APP_API_ENTRYPOINT; // Change this by your own entrypoint
const fetchHeaders = {'Authorization': `Bearer ${window.localStorage.getItem('ltk-comments-admin-token')}`};
const fetchHydra = (url, options = {}) => baseFetchHydra(url, {
    ...options,
    headers: new Headers(fetchHeaders),
});
const messages = {
    en: {
        comments: {
            post: {
                approved: {
                    success: 'Comment Approved',
                    error: {
                        general: 'Error: comment not approved',
                    }
                },
                undelete: {
                    success: 'Comment Undeleted',
                    error: {
                        general: 'Error: comment not undeleted',
                    }
                },
            },
        },
    },
};
const i18nProvider = locale => messages[locale];
const dataProvider = api => hydraClient(api, fetchHydra);
const apiDocumentationParser = entrypoint => parseHydraDocumentation(entrypoint, { headers: new Headers(fetchHeaders) })
    .then(
        // successful authentication and authorization
        ({ api }) => ({ api }),
        // failed authentication and/or authorization
        (result) => {
            switch (result.status) {
                case 401:
                    return Promise.resolve({
                        api: result.api,
                        customRoutes: [{
                            props: {
                                path: '/',
                                render: () => <Redirect to={'/login'}/>,
                            },
                        }],
                    });

                default:
                    return Promise.reject(result);
            }
        }
    );

export default class extends Component {
    state = { api: null };

    componentDidMount() {
        apiDocumentationParser(entrypoint).then(({ api }) => {
            this.setState({ api });
        }).catch((e) => {
            console.log(e);
        });
    }

    render() {
        if (null === this.state.api) return <div>Loading...</div>;
        return (
            <Admin api={ this.state.api }
                   apiDocumentationParser={ apiDocumentationParser }
                   dataProvider= { dataProvider(this.state.api) }
                   theme={ theme }
                   //appLayout={ Layout }
                   authProvider={ authProvider }
                   customRoutes={customAdminRoutes}
                   customReducers={{ tree }}
                   loginPage={CustomLogin}
                   locale="en"
                   i18nProvider={i18nProvider}
            >
                <Resource name="users" icon={ UserIcon } list={ UserList } show={ UserShow } edit={ UserEdit } create={ UserCreate } title="Users"/>
                <Resource name="posts" icon={ PostIcon } list={ PostList } show={ PostShow } edit={ PostEdit } create={ PostCreate } title="Posts"/>
                <Resource name="threads" icon={ ThreadIcon } list={ ThreadList } show={ ThreadShow } edit={ ThreadEdit } create={ ThreadCreate } title="Threads"/>
            </Admin>
        )
    }
}
